import React, { Component } from 'react';
import { connect } from 'react-redux';

import { HYDRA_VIP_DASHBOARD } from 'constants/hydraTests';

import RewardsDashboard from 'containers/account/RewardsDashboard';
import VipDashboard from 'containers/account/VipDashboard';
import { isAssigned, triggerAssignment } from 'actions/ab';

export class RewardsDashboardPicker extends Component {
  static webpackChunkName = 'RewardsDashboard';

  static beforeFetchDataOnServer({ dispatch }) {
    return dispatch(triggerAssignment(HYDRA_VIP_DASHBOARD));
  }

  render() {
    const { isVIPDashboard, location } = this.props;
    return isVIPDashboard ? <VipDashboard location={location} /> : <RewardsDashboard location={location} />;
  }
}

const mapStateToProps = state => ({ isVIPDashboard: isAssigned(HYDRA_VIP_DASHBOARD, 1, state) });

export default connect(mapStateToProps, { triggerAssignment })(RewardsDashboardPicker);
